import { ExperienceModal } from "UIPalette/ExperienceModal/ExperienceModal";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useModalContext } from "shared/core/state/ModalContext/ModalContext";
import { ClickableRoundedCard } from "../ContactCard/ClickableRoundedCard";
import { useLiveChat } from "../LiveChatProvider";
import { useLogReportingEventFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { ReportingEventType } from "shared/constants/ReportingEventType";
import { trackCardClicks, trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";
import { useNotifyModalContext } from "shared/core/state/NotifyModalContext/NotifyModalContext";

export const LiveChatCard = ({
  handleWhatsAppScroll,
  isWhatsAppDisabled,
  startWhatsAppChat,
  useWhatsAppIntegration,
}: {
  handleWhatsAppScroll: () => void;
  isWhatsAppDisabled: boolean;
  startWhatsAppChat: () => void;
  useWhatsAppIntegration: boolean;
}) => {
  const { modalNotify } = useNotifyModalContext();
  const { t } = useTranslation(undefined, { keyPrefix: "support.liveChat" });
  const { isChatAvailable, startChat } = useLiveChat();
  const { trigger } = useLogReportingEventFunctionRequest();
  const { show: showUseWhatsAppModal, isVisible: isUseWhatsAppModalVisible, hide: hideUseWhatsAppModal } = useModalContext("live-chat-maintenace");

  const shouldDisableChatCard = !useWhatsAppIntegration && !isChatAvailable;

  const handleClick = () => {
    trackCardClicks("live-chat");
    if (useWhatsAppIntegration) {
      showUseWhatsAppModal();
    } else {
      trigger({ body: { reportingEventType: ReportingEventType.SupportRequestLiveChat } }).finally(() => startChat());
    }
  };

  const handleDismiss = () => {
    trackEvents(EventNames.LIVE_CHAT_DISMISS);
    hideUseWhatsAppModal();
  };

  const handleThumbsUp = () => {
    if (isWhatsAppDisabled) {
      handleWhatsAppScroll();
    } else {
      startWhatsAppChat();
    }
    trackEvents(EventNames.LIVE_CHAT_THUMBS_UP);
    hideUseWhatsAppModal();
  };

  const handleThumbsDown = () => {
    trackEvents(EventNames.LIVE_CHAT_THUMBS_DOWN);
    hideUseWhatsAppModal();
    modalNotify("success", t("useWhatsApp.thumbsDownSuccess"));
  };

  return (
    <>
      <ClickableRoundedCard
        className={classNames("h-full", { "opacity-50": shouldDisableChatCard })}
        title={t("title")}
        description={shouldDisableChatCard ? t("descriptionOffline") : undefined}
        disabled={shouldDisableChatCard}
        showChevron
        handleClick={handleClick}
      />
      <ExperienceModal
        title={t("title")}
        message={t("useWhatsApp.message")}
        description={t("useWhatsApp.description")}
        isVisible={isUseWhatsAppModalVisible}
        onDismiss={handleDismiss}
        onPositive={handleThumbsUp}
        onNegative={handleThumbsDown}
      />
    </>
  );
};
